import { from } from 'rxjs';
import { TranslateLoader } from '@ngx-translate/core';

export const RootLoader: TranslateLoader = {
  getTranslation: (lang: string) => from(import(`./translations/${lang}.json`)),
};
